import * as React from 'react'

import { styled, spacing, mq } from '@thg-commerce/enterprise-theme'
import { Dropdown, DropdownOption } from '@thg-commerce/gravity-elements'
import { ReviewSort } from '@thg-commerce/enterprise-network/src/generated/graphql'

const StyledDropdown = styled(Dropdown)`
  margin: ${spacing(4)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 50%;
  }
`

export const ReviewSortByDropdown = (props: {
  label: string
  defaultValue?: ReviewSort
  onChange: (sortByType: ReviewSort) => void
  sortByOptions: { sortByType: ReviewSort; text: string }[]
}) => {
  const dropdownOptions = props.sortByOptions.map((option) => (
    <DropdownOption key={option.sortByType} value={option.sortByType}>
      {option.text}
    </DropdownOption>
  ))

  return (
    <StyledDropdown
      labelHidden={false}
      label={props.label}
      defaultValue={props.defaultValue || ReviewSort.NewestToOldest}
      required={true}
      onChange={(event) => props.onChange(event.target.value as ReviewSort)}
    >
      {dropdownOptions}
    </StyledDropdown>
  )
}
